<template>
    <div v-if="error" :class="classes">
        <div v-if="Array.isArray(error)" class="form-error">{{ error.join(',') }}</div>
        <div v-if="error instanceof String" class="form-error">{{ error }}</div>
    </div>
</template>

<script>
export default {
    inheritAttrs: false,
    props: {
        error: [String, Array],
        classes: String,
    },
}
</script>
